import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';

import { baseUrl } from '../utils/globals';

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: createHttpLink({
    uri: `${baseUrl}/public/graphql`,
  }),
});

export default apolloClient;



// WEBPACK FOOTER //
// ./src/graphql/apolloClient.js